import { Application } from '@hotwired/stimulus'
import Lightbox from 'stimulus-lightbox';

export default class extends Lightbox {
  connect() {
    super.connect()

    this.lightGallery;

    this.defaultOptions
  }
}